import React from 'react';
import { motion } from 'framer-motion';
import { Check, Download } from 'lucide-react';
import { Button } from '../components/ui/button';

const highlightsList = [
  "27 Acre Township Development | 27 Towers Master Plan | 11 Towers Launched",
  "35,000 Sq. Ft. Grand Clubhouse | Dual Clubhouses Lifestyle | Premium Amenities",
  "High Speed Branded Elevators | Grand Entrance Lobby | Themed Tower Design",
  "Near Metro & Railway Connectivity | Prime Upper Kharghar Location",
  "G+16 & G+32 Storey Towers | 8 Residences Per Floor | 1 & 2 BHK Smart Homes",
  "Lush Green Landscapes | Central Plaza Musical Fountains | Open Spaces Living",
  "High Street Retail Within Township | Residential + Commercial Living",
  "Seamless Connectivity to Atal Setu | Close to Navi Mumbai International Airport"
];

export default function Highlights({ onBrochureClick }) {
  return (
    <section
      id="highlights"
      data-testid="highlights-section"
      className="py-10 sm:py-12 md:py-16 bg-[#F5F0E8] lg:mr-72 xl:mr-80"
    >
      <div className="max-w-5xl mx-auto px-4">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8 sm:mb-10"
        >
          <h2 className="font-serif text-xl sm:text-2xl md:text-3xl text-[#9A7B4F] mb-2">
            Sai Sun City at Upper Kharghar - Highlights
          </h2>
          <div className="w-12 sm:w-16 h-1 bg-[#9A7B4F] mx-auto" />
        </motion.div>

        {/* Highlights Grid */}
        <div className="grid sm:grid-cols-2 gap-x-6 md:gap-x-12 gap-y-3 sm:gap-y-4">
          {highlightsList.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              className="flex items-start gap-2 sm:gap-3"
            >
              <Check className="w-4 h-4 sm:w-5 sm:h-5 text-[#9A7B4F] flex-shrink-0 mt-0.5" />
              <p className="text-gray-700 text-xs sm:text-sm leading-relaxed">{item}</p>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Welcome Section */}
      <div className="max-w-5xl mx-auto px-4 mt-10 sm:mt-12 md:mt-16">
        <div className="grid md:grid-cols-2 gap-6 md:gap-8 items-center">
          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h3 className="font-serif text-xl sm:text-2xl text-[#9A7B4F] mb-3 sm:mb-4">
              Welcome To Sai Sun City - Upper Kharghar
            </h3>
            <p className="text-gray-600 text-xs sm:text-sm leading-relaxed mb-3 sm:mb-4">
              Sai Sun City at Upper Kharghar is a 27 acre global lifestyle township offering thoughtfully designed 1 & 2 BHK homes across G+16 and G+32 storey towers. With themed architecture, high street retail, and modern infrastructure, it creates a complete residential ecosystem.
            </p>
            <a href="#" className="text-[#9A7B4F] text-xs sm:text-sm font-medium hover:underline">
              Read more ↓
            </a>
            <div className="mt-4 sm:mt-6">
              <Button
                onClick={onBrochureClick}
                className="bg-[#9A7B4F] hover:bg-[#8A6B3F] text-white rounded-none px-5 sm:px-6 py-4 sm:py-5 font-semibold text-xs sm:text-sm"
              >
                <Download className="w-4 h-4 mr-2" />
                Request Brochure
              </Button>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <img
              src="/media/sun_city_walking_area.webp"
              alt="Sai Sun City Walking Area"
              className="w-full h-auto shadow-lg"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
